<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { LocaleProvider } from 'ant-design-vue'
export default {
  name: 'route-view',
  props: {
    keepAlive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  render() {
    const {
      $route: { meta },
      $store: { getters },
    } = this
    const inKeep = (
      <keep-alive>
        <LocaleProvider locale={zhCN}>
          <router-view />
        </LocaleProvider>
      </keep-alive>
    )
    const notKeep = (
      <LocaleProvider locale={zhCN}>
        <router-view />
      </LocaleProvider>
    )
    // 这里增加了 multiTab 的判断，当开启了 multiTab 时
    // 应当全部组件皆缓存，否则会导致切换页面后页面还原成原始状态
    // 若确实不需要，可改为 return meta.keepAlive ? inKeep : notKeep
    if (!getters.multiTab && !meta.keepAlive) {
      return notKeep
    }
    return this.keepAlive || getters.multiTab || meta.keepAlive ? inKeep : notKeep
  },
}
</script>
